<div class="container">
    <p class="title">
  Sailing Performance 
    <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial Performance<mat-icon class="titleIcon">chevron_right</mat-icon> Fleet Itinerary
  </p>
  <mat-tab-group (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Current Voyages">
      <app-current-voyages></app-current-voyages>
    </mat-tab>
    <mat-tab label="Past Voyages"
      ><app-past-voyages #pastVoyages></app-past-voyages>
    </mat-tab>
  </mat-tab-group>
</div>